import React from 'react';
import { Col, Container, FormGroup, Row, Form } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import { useState, useEffect, useRef } from 'react';
import { Auth, SignOut, ListAppSegments, UpdateAppSegment, ListAppConnectorGroups, UpdateAppConnectorGroup } from '../../../functions/ZPA';
import Spinner from 'react-bootstrap/Spinner';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faAngleDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Multiselect from 'multiselect-react-dropdown';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { objectToOperationString } from '../../../functions/misc';
import InputGroup from 'react-bootstrap/InputGroup';
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode'
import { apiKeyCheck, getDatacenters, getServerPlans } from '../../../functions/hetzner';
import { DeployPSE, RunStatus } from '../../../functions/terraform';
import Alert from 'react-bootstrap/Alert';


library.add(faAngleDown)

function PseTab({ groups, verified, showVerifyWindow, setShowVerifyWindow, setVerifyOperation, setVerified, selectedTab }) {
    const [isLoading, setLoading] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState("Authenticating...")
    const [loadingProgress, setLoadingProgress] = useState(0)
    const [tenant, setTenant] = useState("Rheintec");
    const [tenants, setTenants] = useState(["Rheintec"])
    const [tenantsLoading, setTenantsLoading] = useState(true)
    const [outputConsole, setOutputConsole] = useState("");
    const textareaRef = useRef();
    const [description, setDescription] = useState("")
    const [descriptionTag, setDescriptionTag] = useState("")
    const [deployPSE, setDeployPSE] = useState(true)
    const [serverPlans, setServerPlans] = useState([])
    const [datacenters, setDatacenters] = useState([])
    const [selectedDatacenter, setSelectedDatacenter] = useState("")
    const [selectedServerPlan, setSelectedServerPlan] = useState("")
    const [deployDns, setDeployDns] = useState(false)
    const [pseCount, setPseCount] = useState(1)
    const [drVersion, setDrVersion] = useState("1")
    const [drMode, setDrMode] = useState("test")
    const [dnsRecordValue, setDnsRecordValue] = useState(`v=1;b=test;k=zpa;`)
    const dnsManagedTenants = JSON.parse("[\"Rheintec\", \"Credaris\"]")
    const multiselectRef = useRef();
    const run_finished = ["canceled", "errored", "applied", "discarded", "planned_and_finished", "force_canceled", "planned_and_saved"]

    function appendConsole(text) {
        setOutputConsole(prevOutput => prevOutput + text);
    }
    function appendConsoleSeperatorMain(skipNewLine) {
        const width = textareaRef.current.clientWidth;
        const dashesCount = Math.floor(width / 8); // Adjust the number as needed
        const dashes = ('-'.repeat(dashesCount));
        setOutputConsole(prevOutput => prevOutput + (skipNewLine ? "" : "\n") + dashes);
    }
    function appendConsoleSeperatorSecondary() {
        const width = textareaRef.current.clientWidth;
        const dashesCount = Math.floor(width / 8); // Adjust the number as needed
        const dashes = ('-'.repeat(dashesCount / 2));
        setOutputConsole(prevOutput => prevOutput + "\n" + dashes);
    }


    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
    async function authenticate(tenant) {
        try {
            const response = await Auth(tenant);
            const auth_json = await response.json();
            if (response.status === 200) {
                const access_token = auth_json.access_token;
                return access_token;
            }
            else {
                appendConsole(`\nAuth Error: ${tenant} - ${auth_json.message}`);
                appendConsoleSeperatorMain();
            }
        }
        catch (error) {
            console.log(error)
            appendConsole(`\nAuth Error: ${tenant} - ${error.message}`);
            appendConsoleSeperatorMain();
        }
    }


    async function handleSubmit(event) {
        const obj = {
            "Tenant": tenant,
            "Operation": `${deployPSE ? "Deploy" : "Destroy"} Hetzner PSE ${deployDns ? "and DNS records" : ""}`
        }
        if (!verified) {
            try {
                const operationString = objectToOperationString(obj);
                setVerifyOperation(operationString);
                setShowVerifyWindow(true);

            } catch (error) {
                console.log(error)
            } finally {
                event.preventDefault();
                return
            }

        }

        //Prerequisites
        setOutputConsole(``);
        setLoading(true);
        event.preventDefault();

        //Authenticate
        setLoadingMessage("Sending request to terraform...");
        setLoadingProgress(30)
        appendConsole("\nSending requrest to terraform...")
        try {
            const deploy_response = await DeployPSE(tenant, !deployPSE, description, selectedServerPlan, selectedDatacenter, deployDns, dnsRecordValue, pseCount)
            setLoadingProgress(50)
            if (deploy_response.status === 200) {
                const run_id = (await deploy_response.json())["run_id"]
                if (run_id) {
                    appendConsole("\nRequest sent successfully.")
                    appendConsoleSeperatorMain()
                    setLoadingMessage("Checking Terraform Run Status...");
                    setLoadingProgress(80)
                    var status
                    var counter = 1;
                    do {
                        appendConsoleSeperatorSecondary()
                        appendConsole("\nWaiting 10 seconds...")
                        appendConsoleSeperatorSecondary()
                        await sleep(10000);
                        appendConsoleSeperatorSecondary()
                        appendConsole("\nAttempt: " + counter)
                        appendConsole("\nChecking run status...")
                        const status_response = await RunStatus(run_id)
                        if (status_response.status == 200) {
                            status = (await status_response.json())["status"]
                            appendConsole(`\nstatus: ${status}`)
                        } else {
                            appendConsoleSeperatorSecondary()
                            throw new Error("Check failed. Aborting...")
                        }
                        appendConsoleSeperatorSecondary()
                        counter++;
                    } while (!run_finished.includes(status))
                    appendConsoleSeperatorMain()
                    if (status == "applied") {
                        appendConsole("\nDone")
                    }
                    setLoadingProgress(100)
                }
                else {
                    console.log("run_id: " + run_id)
                    appendConsole("\nNo run id returned. Aborting...")
                }

            } else {
                appendConsole("\nRequest failed:")
                const json = await deploy_response.json()
                appendConsole(`${json.message}`)
                setLoadingProgress(100)
            }


            terminate()
        }
        catch (error) {
            appendConsole(`\nError: ${error.message}`)
            console.log(error)
            terminate()
        }



    }

    useEffect(() => {
        if (selectedTab === "pse" && verified) {
            handleSubmit(new Event("LOL"))
        }
        setVerified(false);
    }, [verified])

    function terminate() {
        setLoadingMessage('')
        setLoading(false)
        setLoadingProgress(0)
    }
    // Function to scroll the textarea to the bottom
    const scrollToBottom = () => {
        textareaRef.current.scrollTop = textareaRef.current.scrollHeight;
    };

    const scrollToTop = () => {
        textareaRef.current.scrollTop = 0;
    };


    useEffect(() => {
        getServerPlans(tenant).then(async (response) => {
            if (response.status === 200) {
                const plans = await response.json();
                setServerPlans(plans)
            } else {
                setServerPlans([])
            }
        })
        getDatacenters(tenant).then(async (response) => {
            if (response.status === 200) {
                const datacenters = await response.json();
                setDatacenters(datacenters)
            } else {
                setDatacenters([])
            }
        })
    }, [tenant])

    useEffect(() => {
        scrollToBottom();
    }, [outputConsole])

    useEffect(() => {
        scrollToTop();
    }, [isLoading])

    useEffect(() => {
        setDrMode("test")
        setDrVersion("1")
    }, [deployDns])

    useEffect(() => {
        setDnsRecordValue(`v=${drVersion};b=${drMode};k=zpa;`);
    }, [drMode, drVersion]);
    useEffect(() => {
        setDeployDns(false)
    }, [deployPSE]);

    useEffect(() => {
        const JWT = Cookies.get('CF_Authorization');
        const decodedJWT = jwtDecode(JWT)
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const date = `${day}-${month}-${year}`;
        setDescriptionTag(`${date}/${decodedJWT.email}`)
        setTenantsLoading(true)
        const fetchTenants = async () => {
            const available_tenants = []
            await Promise.all(Object.keys(groups).map(async (key) => {
                const response = await apiKeyCheck(key)
                if (response.status === 200) {
                    available_tenants.push(key)
                }
            }))
            setTenants(available_tenants)
            setTenantsLoading(false)
        }
        fetchTenants()
    }, [])



    return (

        <Container className=' pt-4 px-5 text-white pb-6'>
            <Row>
                <Col>
                    <Form onSubmit={handleSubmit}>
                        <FormGroup controlId="company">
                            <Form.Label>
                                {tenantsLoading ?
                                    <>
                                        <Spinner
                                            variant='light'
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                        />
                                        &nbsp;&nbsp;
                                    </> : <></>}
                                Select tenant
                            </Form.Label>
                            <Form.Select aria-label="Default select example" value={tenant} onChange={(e) => setTenant(e.target.value)} >
                                {
                                    tenants.map((key, index) => (
                                        <option key={index} value={key}>{key}</option>
                                    ))

                                }
                            </Form.Select>
                        </FormGroup>

                        <FormGroup controlId="company" className='mt-4'>
                            <Form.Label>
                                PSE
                            </Form.Label>
                            <Form.Select required value={deployPSE} onChange={(e) => setDeployPSE(e.target.value === 'true')} >
                                <option value={true}>
                                    Deploy
                                </option>
                                <option value={false}>
                                    Destroy
                                </option>
                            </Form.Select>
                        </FormGroup>

                        {deployPSE ?
                            <>
                                <FormGroup controlId="Target" className='mt-4'>
                                    <Form.Label>
                                        {serverPlans.length === 0 ?
                                            <>
                                                <Spinner
                                                    variant='light'
                                                    as="span"
                                                    animation="border"
                                                    size="sm"
                                                    role="status"
                                                />
                                                &nbsp;&nbsp;
                                            </> : <></>}
                                        Datacenter
                                    </Form.Label>
                                    <Form.Select required value={selectedDatacenter} onChange={(e) => setSelectedDatacenter(e.target.value)} >
                                        {datacenters.length === 0 ? <option value="">Loading Datacenters...</option> : <option value="">Select Datacenter</option>}
                                        {datacenters.map((option) => (
                                            <option key={option.key} value={option.key}>
                                                {option.description}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </FormGroup>
                                <FormGroup controlId="company" className='mt-4'>
                                    <Form.Label>
                                        PSE Count
                                    </Form.Label>
                                    <Form.Select required value={pseCount} onChange={(e) => setPseCount(e.target.value)} >
                                        {Array.from({ length: 9 }, (_, i) => (
                                            <option key={i + 1} value={i + 1}>
                                                {i + 1}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </FormGroup>
                                <FormGroup controlId="Target" className='mt-4'>
                                    <Form.Label>
                                        {serverPlans.length === 0 ?
                                            <>
                                                <Spinner
                                                    variant='light'
                                                    as="span"
                                                    animation="border"
                                                    size="sm"
                                                    role="status"
                                                />
                                                &nbsp;&nbsp;
                                            </> : <></>}
                                        Server Plans
                                    </Form.Label>
                                    <Form.Select equired value={selectedServerPlan} onChange={(e) => setSelectedServerPlan(e.target.value)} >
                                        {serverPlans.length === 0 ? <option value="">Loading plans...</option> : <option value="">Select Plan</option>}
                                        {serverPlans.map((option) => (
                                            <option key={option.key} value={option.key}>
                                                {option.description}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </FormGroup>
                            </>
                            :
                            <></>
                        }
                        {
                            dnsManagedTenants.includes(tenant) && deployPSE
                                ?
                                <FormGroup controlId="company" className='mt-4'>
                                    <Form.Check
                                        type="switch"
                                        id="custom-switch"
                                        label="Deploy DNS Records"
                                        checked={deployDns}
                                        onChange={(e) => setDeployDns(e.target.checked)} state
                                    />
                                </FormGroup>

                                :
                                <></>
                        }


                        {deployDns && deployPSE ?
                            <>
                                <FormGroup controlId="company" className='mt-4'>
                                    <Form.Label>
                                        ZPA DR Mode
                                    </Form.Label>
                                    <Form.Select required value={drMode} onChange={(e) => setDrMode(e.target.value)} >
                                        <option value="test">
                                            Test
                                        </option>
                                        <option value="on">
                                            On
                                        </option>
                                        <option value="off">
                                            Off
                                        </option>
                                    </Form.Select>
                                </FormGroup>
                                <FormGroup controlId="company" className='mt-4'>
                                    <Form.Label>
                                        ZPA DR Version
                                    </Form.Label>
                                    <Form.Select required value={drVersion} onChange={(e) => setDrVersion(e.target.value)} >
                                        {Array.from({ length: 9 }, (_, i) => (
                                            <option key={i + 1} value={i + 1}>
                                                {i + 1}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </FormGroup>
                                <FormGroup controlId="company" className='mt-4'>
                                    <Form.Label>
                                        DNS Record Value Preview
                                    </Form.Label>
                                    <InputGroup className="">
                                        <Form.Control disabled type='text' required value={dnsRecordValue} />
                                    </InputGroup>
                                </FormGroup>
                            </> : <></>}

                        <FormGroup controlId="description" className='mt-4'>
                            <Form.Label>
                                Description (Will be added to the description of the terraform run)
                            </Form.Label>

                            <InputGroup className="">
                                <InputGroup.Text id="basic-addon2">{descriptionTag}</InputGroup.Text>
                                <Form.Control type='text' required value={description} onChange={(e) => setDescription(e.target.value)} placeholder='Some Description...' />
                            </InputGroup>
                        </FormGroup>





                        <Button className='mt-4 text-light' type='submit' disabled={isLoading} variant={deployPSE ? "success" : "danger"} >
                            {isLoading ?
                                <span>
                                    <Spinner
                                        variant='light'
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                    {"  " + loadingMessage}
                                </span> : deployPSE ? "Deploy PSE" : "Destroy PSE"}
                        </Button>
                    </Form>
                </Col>
            </Row>
            <Row className='mt-5 '>
                <Col>
                    <ProgressBar className='mb-2' now={0} />
                </Col>
            </Row>
            <Row className='mt-0 text-center'>
                <Col className=''>
                    <textarea value={outputConsole} className='w-100 bg-dark-subtle text-rheintec-blue output-terminal' rows="20" readOnly ref={textareaRef}>
                    </textarea>
                </Col>

            </Row>

        </Container >

    );

}

export default PseTab;